import { FC } from 'react'
import { Digit } from './digit'
import { CounterWrapper } from './styled'

type Props = {
  value: number | string
  animated?: boolean
}

export const Counter: FC<Props> = ({ value, animated = false }) => {
  return (
    <CounterWrapper>
      {value
        .toString()
        .split('')
        .map((v, i) => (
          <Digit value={v} key={i} animated={animated} />
        ))}
    </CounterWrapper>
  )
}
